export default "__VITE_ASSET__BNGPhjoh__"